const getDisplayTranslation = (translations = [], preferredLanguage = "en") =>
  translations.find(
    (translation) => translation.language === preferredLanguage
  ) ||
  translations.find((translation) => translation.language === "en") ||
  translations[0] ||
  null;

export default getDisplayTranslation;
